import React from 'react'

function Placmant() {
  return (
    <div id="target-section">Placmant</div>
  )
}

export default Placmant